import React from 'react'
import { CountChipEl } from './CountChip.styles'

interface CountChipProps {
	children: React.ReactNode
}

/** Small grey count pill shown in a tile header (e.g. "16 days", "6"). */
const CountChip: React.FC<CountChipProps> = ({ children }) => <CountChipEl>{children}</CountChipEl>

export default CountChip
